/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRootPage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h10.414L20 7.586V22H4V2zm2 2v16h12V9h-5V4H6zm9 1.414V7h1.586L15 5.414zM10.586 13H7v-2h10v2h-3.586l3.293 3.293-1.414 1.414L12 14.414l-3.293 3.293-1.414-1.414L10.586 13z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRootPage as RootPage };
